import { forwardRef, useImperativeHandle, useLayoutEffect, useRef } from "react";

// Single-line start, grows with content, scrolls past maxHeight. Enter sends, Shift+Enter = newline.
const AutoTextarea = forwardRef(function AutoTextarea({ value, onChange, onSend, maxHeight = 180, style, className, ...rest }, ref) {
  const inner = useRef(null);
  useImperativeHandle(ref, () => inner.current);
  useLayoutEffect(() => {
    const el = inner.current; if (!el) return;
    el.style.height = "auto";
    const h = Math.min(el.scrollHeight, maxHeight);
    el.style.height = h + "px";
    el.style.overflowY = el.scrollHeight > maxHeight ? "auto" : "hidden";
  }, [value, maxHeight]);
  return (
    <textarea ref={inner} rows={1} value={value || ""} onChange={(e) => onChange?.(e.target.value)}
      onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); onSend?.(); } }}
      className={`yuo-auto-ta ${className || ""}`}
      style={{ resize: "none", overflowX: "hidden", overflowWrap: "anywhere", whiteSpace: "pre-wrap", boxSizing: "border-box", display: "block", lineHeight: "20px", boxShadow: "none", borderRadius: 0, ...style }}
      {...rest} />
  );
});

export default AutoTextarea;
